/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'backdrop.scss' instead.
import { css } from 'lit';
export default css `:host{background:var(--cipublic-backdrop);box-sizing:border-box;display:none;height:100%;left:0;min-height:100vh;position:fixed;top:0;width:100%;z-index:var(--cipublic-zindex-200)}:host([active]){display:block}:host([inverted]){background:var(--cipublic-inverted-backdrop)}`;
//# sourceMappingURL=backdrop.scss.js.map